import React from 'react';
import { isDesktop, isIOS, isAndroid } from 'react-device-detect';
import { Icons } from './icons';

// displays Apple App Store, Google Play Store or Both depending on device / screen size.
const AppStore = () => {
  const APKUrl =
    'https://play.google.com/store/apps/details?id=com.sevenstore.sevenapp&hl=en_GB';
  const IOSUrl = 'https://apps.apple.com/gb/app/sevenstore/id1179005758';

  return (
    <>
      {(isDesktop || isIOS) && (
        <a
          href={IOSUrl}
          style={{ color: '#fff', width: '100%' }}
          rel="_blank"
          referrerPolicy="no-referrer"
        >
          <div className="w-full">
            <Icons.AppStore className="rounded-lg border border-solid border-[#E0E0E0] lg:border-2" />
          </div>
        </a>
      )}
      {(isDesktop || isAndroid) && (
        <a
          href={APKUrl}
          style={{ color: '#fff', width: '100%' }}
          rel="_blank"
          referrerPolicy="no-referrer"
        >
          <div className="w-full">
            <Icons.PlayStore className="rounded-lg border border-solid border-black lg:border-2" />
          </div>
        </a>
      )}
    </>
  );
};

export default AppStore;
